import { Block } from '@chameleoncreator/creator-app';

export const focusBlockAction = (block: Block) => ({
  type: 'FOCUS_BLOCK',
  data: block,
});
